// extracted by mini-css-extract-plugin
module.exports = {"formTitleContainer":"Rate_formTitleContainer__eUoPf","formItemContainer":"Rate_formItemContainer__1K8EC","formTitle":"Rate_formTitle__1o5CD"};